export default {"src":"/_next/static/media/TJHeaderLogo.5af231fd.svg","height":24,"width":210,"blurWidth":0,"blurHeight":0};